$('.n23-slider').slick({
  centerMode: true,
  centerPadding: '30%',
  slidesToShow: 1,
  autoplay: true,
  autoplaySpeed: 4000,
  dots: true,
  prevArrow: '<div class="slick-prev"></div>',
  nextArrow: '<div class="slick-next"></div>',
  responsive: [
    {
      breakpoint: 750,
      settings: {
        centerPadding: '0',
      }
    }
  ]
});
